import { Button, Modal } from '../../../../../components'
import { ModalProps } from '../../../../holidays/components/types'

const AlertPopup = ({ show, onClose }: ModalProps) => {
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Alert"
            body={
                <>
                    <p className="del-desc">User Already Exist</p>
                    <div className="footer-block">
                        <Button
                            type="submit"
                            onClick={async () => {
                                onClose(false)
                            }}
                        >
                            OK
                        </Button>
                    </div>
                </>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default AlertPopup
